import * as React from "react";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonList,
  ManagementSpecCommonListStore,
} from "../ManagementSpecCommon";
import { ObjectsManager } from "../ObjectsManager";

const pageStore = new ManagementSpecCommonListStore({
  specType: "primary",
});

export const ManagementPrimSpecs: React.FC = () => (
  <ObjectsManager tab="primSpecs">
    <ManagementSpecCommonList
      cardUrl={PageUrl.managementPrimSpecCard}
      pageStore={pageStore}
    />
  </ObjectsManager>
);
